export const formatNumberWithCommas = (number) => {
  if (number === undefined || number === null || isNaN(number)) return '';
  return Number(number).toLocaleString();
};
